module.exports = __webpack_public_path__ + "img/banner.5968dfc6.png";